import type { NativeGameFrame } from './nativeFrame.ts';
import { resolveLegacyPoseKeypoints } from './nativeFrame.ts';
import type { PoseKeypoint } from './pose.ts';

/**
 * Target Attack WebRTC: native may send
 * - full TA payloads (`gameState`, `player1`, `targets`, `labels`, …), or
 * - `FruitNinjaData`-style frames (`keypoints`, `fruits`, `aspectRatio`, `fruitSize`, …) during gameplay
 *   without `targets` / `player1` — TV still must drive pose from top-level `keypoints`.
 *
 * Uses the same pose resolution as the TV browser (merged `keypoints` vs `player1`/`player2`).
 */
export function resolveTargetAttackPoseKeypoints(frame: NativeGameFrame): readonly PoseKeypoint[] {
  return resolveLegacyPoseKeypoints(frame);
}
